import React from 'react';
import type { Bonus } from '../types/content';
type BonusCoverProps = {
  bonus: Bonus;
  className?: string;
};
export function BonusCover({
  bonus,
  className = ''
}: BonusCoverProps) {
  return <img src={bonus.coverImage} alt={`Cover: ${bonus.name}`} loading="lazy" className={`h-auto w-full rounded-lg shadow-sheet ring-1 ring-navy/5 ${className}`} data-id="element-21" data-mp="3d2fyevz3toro" />;
}